import { ApiProperty } from '@nestjs/swagger';

export class ActivityStateRefResponseDto {
  @ApiProperty({ type: 'string' })
  id!: string;

  @ApiProperty({ type: 'string' })
  code!: string;

  @ApiProperty({ type: 'string' })
  label!: string;
}
